<template>
  <div>
    <Loading v-if="isLoading"/>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <ol class="breadcrumb">
            <li><a :href="home_url"> HOME</a>
            </li>
            <li>{{$t('archive')}}</li>
          </ol>
        </div>
      </div>
    </div>
    <section class="archives-main">
      <h1 v-html="$t('archive_list_title')"></h1>
    </section>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="mb-4" v-html="$t('archive_list_description')"></p>
          <section class="area-search">
            <h2><span>{{$t('search_by_location')}}</span></h2>
            <dl class="area-search-dl">
              <dt>{{$t('search_by_area')}}</dt>
              <dd v-if="areas.length > 0">
                <ul>
                  <li v-for="area in areas" :key="area.id">
                    <router-link :to="{name: 'ArtifactAssetList', params: {selectedArea: area}}" class="r-icon"
                                 :class="area.slug">
                      {{area.name}}
                    </router-link>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl class="remains-search-dl">
              <dt>{{$t('search_by_site')}}</dt>
              <dd v-if="sites.length > 0">
                <ul>
                  <template v-for="site in sites" :key="site.id">
                    <li>
                      <router-link :to="{name: 'ArtifactAssetList', params: {selectedSite: site}}"
                                   :class="getAreasBySite(site)">
                        {{ site.title }}
                      </router-link>
                    </li>
                  </template>
                </ul>
              </dd>
            </dl>
          </section>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="tag-search">
            <h2><span>{{$t('search_by_tags')}}</span></h2>
            <ul v-if="showTags.length > 0" class="taglist row">
              <li v-for="tag in showTags" :key="tag.id" class="col-12 col-md-6 col-xl-4">
                <router-link :to="{name: 'AssetTagList', params: {slug: tag.slug}}">
                  <img :src="tag.image">
                  <span>#{{ tag.name }}</span>
                </router-link>
              </li>
            </ul>
            <div class="more-tags">
              <button type="button" data-toggle="collapse" data-target="#collapse-tag"
                      aria-expanded="false" aria-controls="collapse-tag">{{$t('show_all_tag')}}<br><span
                  class="material-icons">
                                        expand_more
                                        </span>
              </button>
            </div>
            <div class="collapse" id="collapse-tag">
              <div class="tag-box">
                <ul class="taglist-other list-inline">
                  <li v-for="tag in moreTags" :key="tag.id" class="list-inline-item">
                    <router-link :to="{name: 'AssetTagList', params: {slug: tag.slug}}">
                      <span>#{{ tag.name }}</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="content"><!--ここからコンテンツ-->
            <section class="new-item" v-if="assetTypes.length > 0">
              <h2><span>{{$t('recently_added')}}</span></h2>
              <dl v-for="type in assetTypes" :key="type.id">
                <dt :class="getIconBySlug(type.slug)">
                  <span>{{ type.name }}</span>
                  <router-link :to="{name: 'AssetTypeList', params: {type: type.slug}}">View more</router-link>
                </dt>
                <dd>
                  <AssetList per_page="5" :selectedTypes="[type.id]" :show_pagination="false"/>
                </dd>
              </dl>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../components/Loading";
import axios from "axios";
import AssetList from "../components/AssetList";

export default {
  name: "ArchivesList",
  components: {AssetList, Loading},
  data() {
    return {
      isLoading: false,
      areas: [],
      sites: [],
      tags: [],
      assetTypes: [],
      lang: lang,
      home_url: home_url
    }
  },
  mounted() {
    window.history.scrollRestoration = "manual"
    window.scrollTo(0, 0)
  },
  computed: {
    showTags() {
      return this.tags.filter(item => {
        return item.image !== null
      }).sort(function(item1, item2) {
        return item1.order - item2.order;
      })
    },
    moreTags() {
      return this.tags.filter(item => {
        return item.image == null
      })
    }
  },
  created() {
    this.listAreas()
  },
  methods: {
    getIconBySlug(slug){
      switch(slug) {
        case 'image':
          return 'search-icon';
        case 'files':
          return 'book-icon';
        case 'movie':
          return 'book-icon';
        default:
          return ''
      }
    },
    getAreasBySite(site) {
      if(site.area.parent !== null){
        return site.area.parent_slug;
      }else{
        return site.area.slug
      }
    },
    listAreas() {
      this.isLoading = true
      let params = {
        lang: this.lang,
        type: 'site-area',
        slugs: 'jomon-archaeological-sites,hokkaido,aomori,iwate,akita'
      }
      const config = {
        params: params
      }
      axios.get('/api/terms', config)
          .then((res) => {
            this.areas = res.data.data
          })
          .finally(() => {
            this.getSites()
          })
          .catch((error) => {
            console.log(error)
          })
    },
    getSites() {
      const config = {
        params: {
          lang: this.lang
        }
      }
      axios.get('/api/sites', config)
          .then((res) => {
            this.sites = res.data
          })
          .finally(() => {
            this.getTags()
          })
    },
    getTags() {
      let params = {
        lang: this.lang,
        type: 'asset-tag'
      }
      const config = {
        params: params
      }
      axios.get('/api/terms', config)
          .then((res) => {
            this.tags = res.data.data
          })
          .finally(() => {
            this.getAssetType()
          })
          .catch((error) => {
            console.log(error)
          })
    },
    getAssetType() {
      let params = {
        lang: this.lang,
        type: 'asset-type'
      }
      const config = {
        params: params
      }
      axios.get('/api/terms', config)
          .then((res) => {
            this.assetTypes = res.data.data.sort(function(item1, item2) {
              return item1.order - item2.order;
            })
          })
          .finally(() => {
            this.isLoading = false
          })
          .catch((error) => {
            console.log(error)
          })
    },
  }
}
</script>

<style scoped>

</style>
